import * as React from 'react';
import styled from 'styled-components';
import TableCustomers from '../../table/TableCustomers';
import { Customer } from '../../../domain/customer/Customer';
import { CustomerList } from '../../../domain/customer/CustomerList';
import { Label } from '../input/Label';
import Input from '../input/Input';
import Button from '../button/Button';
import { getResolveJSON } from '../../../util/fetch';
import { getBaseURL } from '../../../config/runtime';

interface Props {
  openAddCustomerForm: () => void;
}

const Content = styled.section`
  padding: 1rem 1.5rem 1.5rem;
  position: relative;
`;

const Lbl = styled(Label)`
  margin-top: .4rem;
`;

const ButtonLabel = styled.label`
  font-weight: bold;
  user-select: none;
`;

const buttonStyles = `
  position: absolute;
  right: 1.5rem;
  top: 0.6rem;
`;

let timeoutHandle = null;

const Search = (props: Props) => {
  const [customers, setCustomers] = React.useState<Customer[]>([]);

  const resetTimeout = () => {
    clearTimeout(timeoutHandle);
    timeoutHandle = null;
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const search = e.target.value;
    if (timeoutHandle !== null) {
      resetTimeout();
    }

    if (search === '') {
      setCustomers([]);
      return;
    }

    timeoutHandle = setTimeout(async () => {
      resetTimeout();
      const customers = (await fetchCustomers(search));
      setCustomers(customers);
    }, 350);
  };

  const fetchCustomers = async (search: string) => {
    const customerList = await getResolveJSON<CustomerList>(`${getBaseURL()}/v1/cmd/customers?search=${search}`);
    return customerList.data;
  };

  return (
    <Content>
      <Lbl>Customer search</Lbl>
      <Button onClick={() => props.openAddCustomerForm()} styles={buttonStyles}>
        <ButtonLabel>Add Customer</ButtonLabel>
      </Button>
      <Input
        autoFocus
        onChange={onSearchChange}
        placeholder="Begin typing a customer ID, username or email to run a search."
      />
      <TableCustomers customers={customers} />
    </Content>
  );
};

export default Search;
